
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import AppFieldEdit from "./FieldEdit.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { Field } from "@/utils/documents/field";
import Vue from "vue";
import { getReminderMapPropSelectGroup } from "@/utils/prop-select/reminder-map-prop-group";

export default Vue.extend({
	data() {
		return{
			selectedLang: "",
			toEditStyleProp: null as null | Field,
			toEditProp: null as null | Field,
		};
	},
	props: {
		line: Array as () => Field[],
		title: String
	},
	computed: {
		reminderMapPropSelectGroup():PropSelectGroup{
			return getReminderMapPropSelectGroup();
		}
	},
	methods: {
		addItemClicked() {
			this.line.push(new Field());
		},
		removeItem(index: number) {
			this.line.splice(index, 1);
		},
		editStyle(style: Field) {
			this.toEditStyleProp = style;
		},
		editProp(prop: Field) {
			this.toEditProp = prop;
		},
		getPropValue(prop: Field): string {
			if (!prop.Prop) return "";
			let val = this.reminderMapPropSelectGroup.getPropSelectFromValue(prop.Prop);
			if (!val) return "";
			return val.text.toString();;
		}
	},
	components: {
		AppCustomLangSelect,
		AppStyleEditor,
		AppFieldEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
